import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import routes from "../../services/routes";
import { Loader } from "../../services/helper";
import { useAuth } from "../../services/AuthContext";

export default function AppContent() {
  const { isLoading } = useAuth();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setInitialized(true);
    }
  }, [isLoading]);

  if (isLoading || !initialized) {
    return <Loader />;
  }

  return (
    <React.Suspense fallback={<Loader />}>
      <Routes>
        {routes?.map((route, indx) => {
          return (
            route?.element && (
              <Route
                key={indx}
                exact={route?.exact}
                path={route?.path}
                name={route?.name}
                element={<route.element />}
              />
            )
          );
        })}
        {/* <Route path="/" element={<Navigate to="dashboard" replace />} /> */}
      </Routes>
    </React.Suspense>
  );
}
